import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Loader from 'app/components/general/Loader';

import LoadingBar from 'react-top-loading-bar';
import classnames from 'classnames';

import SideBar from 'app/components/layout/SideBar';
import Footer from 'app/components/layout/Footer';

import _ from 'lodash';
import * as loadingActions from 'app/ducks/loading/actions';

import * as loadingSelectors from 'app/ducks/loading/selectors';

const authentication = (state) => state.authentication;

export function selector(state) {
  return {
    ...authentication,
    loading: {
      ...loadingSelectors.getLoading(state),
    },
  };
}

interface IRenderContentProps {
  loading: any;
  children: any;
  match: any;
  authentication: any;
  className: string;
  isModal: boolean;
}

const actionCreators = _.merge(loadingActions);

@connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
}))
export default class RenderContent extends React.Component<IRenderContentProps> {
  static defaultProps: IRenderContentProps = {
    loading: undefined,
    children: undefined,
    match: undefined,
    authentication: undefined,
    className: undefined,
  };

  render(): React.ReactNode {
    if (this.props.isModal) {
      return (
        <div>
          <div className="global-loading">
            <Loader isActive={this.props.loading.isLoading} color="grey" />
          </div>
          {this.props.children}
        </div>
      );
    }
    return (
      <div className={`h-100 ${this.props.className}`}>
        <div className="wrapper">
          <div className="global-loading">
            <Loader isActive={this.props.loading.isLoading} color="grey" />
          </div>
          <SideBar {...this.props} />
          <div className="container-fluid container-content">
            {this.props.children}
            <div className="push" />
          </div>
        </div>
      </div>
    );
  }
}
